import { render } from "./CategoriesComponent.vue?vue&type=template&id=f2ee442a"
import script from "./CategoriesComponent.vue?vue&type=script&lang=js"
export * from "./CategoriesComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__